import "./App.css";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import { Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Categories from "./pages/Categories";
import DetailsPond from "./pages/DetailsPond";
import DetailsBoite from "./pages/DetailsBoite";
import DetailsMoteur from "./pages/DetailsMoteur";
import DetailsHydraulique from "./pages/DetailsHydraulique";
import DetailsCabine from "./pages/DetailsCabine";
import { useState } from "react";
import React from 'react'


function App() {
  const product = [
    
{
  name: " ECROU GOUJON DE ROUE ",
  categories: " GROUPE POND ",
  image: "../image_produit/106-40001.jpg",
  reference: "BPS-001106",
},

{
  name: "GOUJON DE ROUE ",
  categories: " GROUPE POND ",
  image: "../image_produit/826-00533.jpg ",
  reference: "BPS-002826",
},

{
  name: "CLE DE ROUE ",
  categories: " GROUPE POND ",
  image: "../image_produit/825-99928.jpg",
  reference: "BPS-003825",
},
{
  name: "PARAHUILE POND ",
  categories: " GROUPE POND ",
  image: "../image_produit/904-50040.jpg",
  reference: "BPS-004904 ",
},
{
  name: "CHAP FUSEE ",
  categories: " GROUPE POND ",
  image: "../image_produit/448-03902.jpg ",
  reference: "BPS-005448 ",
},
{
  name: "PARAGRAISSE ",
  categories: " GROUPE POND ",
  image: "../image_produit/904-06700.jpg",
  reference: "BPS-006904 ",
},
{
  name: "ROULEMENT FUSEE ",
  categories: " GROUPE POND ",
  image: "../image_produit/907-08300.jpg ",
  reference: "BPS-007907 ",
},
{
  name: "ROULEMENT SEMI ARBRE ",
  categories: " GROUPE POND ",
  image: "../image_produit/917-50200.jpg",
  reference: "BPS-008917 ",
},
{
  name: "CROISILLON ",
  categories: " GROUPE POND ",
  image: "../image_produit/914-80207.jpg ",
  reference: "BPS-009914 ",
},
{
  name: "ARBRE CARDON AV",
  categories: " GROUPE POND ",
  image: "../image_produit/914-88101.jpg",
  reference: "BPS-010914 ",
},
{
  name: "CACHE REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/450-12401.jpg",
  reference: "BPS-011450 ",
},
{
  name: "PIGNON CENTRAL ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-12403.jpg ",
  reference: "BPS-012450 ",
},
{
  name: "CIRCLIPS PIGNON CENTRAL",
  categories: " GROUPE POND ",
  image: "../image_produit/821-00494.jpg",
  reference: "BPS-013821 ",
},
{
  name: "PIGNON REDUCTEUR ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10206.jpg ",
  reference: "BPS-014450 ",
},
{
  name: "ROULEMENT REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/907-50200.jpg",
  reference: "BPS-015907 ",
},
{
  name: "CIRCLIPS ROULEMENT REDUCTEUR ",
  categories: " GROUPE POND ",
  image: "../image_produit/821-00209.jpg ",
  reference: "BPS-016821 ",
},
{
  name: "CIRCLIPS PIGNON REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/2203-0054.jpg ",
  reference: "BPS-017220 ",
},
{
  name: "COURONE REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10205.jpg ",
  reference: "BPS-018450",
},
{
  name: "ROULEMENT MOYEU",
  categories: " GROUPE POND ",
  image: "../image_produit/907-52200.jpg ",
  reference: "BPS-019907",
},
{
  name: "PARAHUILE MOYEU ",
  categories: " GROUPE POND ",
  image: "../image_produit/904-50033.jpg",
  reference: "BPS-020904",
},
{
  name: "VIS+COURONE 13/38 ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10700.jpg",
  reference: "BPS-021450",
},
{
  name: "KIT REPARATION DIFFERENTIEL",
  categories: " GROUPE POND ",
  image: "../image_produit/450-11000.jpg",
  reference: "BPS-022450",
},
{
  name: "ROULEMENT VIS INTERIEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/907-09000.jpg  ",
  reference: "BPS-023907",
},
{
  name: "ECROU VIS ",
  categories: " GROUPE POND ",
  image: "../image_produit/826-01483.jpg  ",
  reference: "BPS-024826 ",
},
{
  name: "JEUX RONDELLE BRONZE DIFFERENTIEL",
  categories: " GROUPE POND ",
  image: "../image_produit/808-00209-10.jpg",
  reference: "BPS-025808 ",
},
{
  name: "ROTULE DE DIRECTION ",
  categories: " GROUPE POND ",
  image: "../image_produit/126-02253.jpg ",
  reference: "BPS-027126",
},
{
  name: "BOULE DE ROTULE",
  categories: " GROUPE POND ",
  image: "../image_produit/331-14861.jpg",
  reference: "BPS-028331",
},
{
  name: "SEMI ARBRE POND AR ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10209.jpg ",
  reference: "BPS-029450",
},
{
  name: "VIS+COURONE 13/33 ",
  categories: " GROUPE POND ",
  image: "../image_produit/458-70140.jpg",
  reference: "BPS-030458",
},
{
  name: "ROULEMENT DIFFERENTIEL ",
  categories: " GROUPE POND ",
  image: "../image_produit/907-50100.jpg",
  reference: "BPS-031907",
},
{
  name: "DISQUE DE FREIN ",
  categories: " GROUPE POND ",
  image: "../image_produit/458-20353.jpg",
  reference: "BPS-032458",
},
{
  name: "CONTRE DISQUE DE FREIN",
  categories: " GROUPE POND ",
  image: "../image_produit/458-20285.jpg ",
  reference: "BPS-033458",
},
{
  name: "JEUX JOINT DE PISTON DE FREIN",
  categories: " GROUPE POND ",
  image: "../image_produit/813-50026-12.jpg",
  reference: "BPS-034813",
},
{
  name: "CROISILLON 106*35",
  categories: " GROUPE POND ",
  image: "../image_produit/914-36401.jpg",
  reference: "BPS-035914",
},
{
  name: "CROISILLON 126*35",
  categories: " GROUPE POND ",
  image: "../image_produit/914-45301.jpg",
  reference: "BPS-036914",
},
{
  name: "ATTACHE CROISILLON ",
  categories: " GROUPE POND ",
  image: "../image_produit/116-00525.jpg",
  reference: "BPS-037116",
},
{
  name: "VIS  D’ATTACHE ",
  categories: " GROUPE POND ",
  image: "../image_produit/826-00892.jpg ",
  reference: "BPS-038826",
},
{
  name: "PARAHUILE  POND ",
  categories: " GROUPE POND ",
  image: "../image_produit/904-50023.jpg",
  reference: "BPS-039904",
},
{
  name: "COMODO DE VITESSE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-80298 .jpg",
  reference: "BPS-040701",
},
{
  name: "REFROIDISSEUR ANCIEN MODEL ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/30-925441.jpg",
  reference: "BPS-041030 ",
},
{
  name: "AXE DIFFERENTIEL",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10903.jpg",
  reference: "BPS-042450",
},
{
  name: "SUPPORT MOTEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/331-40347.jpg",
  reference: "BPS-043331",
},
{
  name: "PARAHUILE POMPE A HUILE ",
  categories: "  GROUPE BOITE ",
  image: "../image_produit/20-915901.jpg ",
  reference: "BPS-044020",
},
{
  name: "DISQUE D’EMBRAYAGE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-03205.jpg ",
  reference: "BPS-045445",
},
{
  name: "DISQUE D’EMBRAYAGE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-30011.jpg ",
  reference: "BPS-046445",
},
{
  name: "CONTRE DISQUE D’EMBRAYAGE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-12307.jpg   ",
  reference: "BPS-047445",
},
{
  name: "JOINT ELECTROVANE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/813-10175.jpg",
  reference: "BPS-048813",
},
{
  name: "PISTON BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/449-11370.jpg",
  reference: "BPS-050449",
},
{
  name: "SEGMENT BOITE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/904-50020.jpg ",
  reference: "BPS-051904",
},
{
  name: "JEUX JOINT BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/828-00154-55.jpg",
  reference: "BPS-052828",
},
{
  name: "BOBINE ELECTROVANE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/477-00824.jpg",
  reference: "BPS-055477",
},
{
  name: "NECESSAIRE DISTRIBUTEUR",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/25-221208.jpg",
  reference: "BPS-059025",
},
{
  name: "LEVIER SELECTEUR SUPERIEUR ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-05501.jpg",
  reference: "BPS-060445",
},
{
  name: "LEVIER SELECTEUR INFERIEUR",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-05503.jpg   ",
  reference: "BPS-060/1.445 ",
},
{
  name: "RONDELLE TEFLON LEVIER DE VITESSE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-10802.jpg",
  reference: "BPS-061445",
},
{
  name: "RONDELLE TEFLON LEVIER DE VITESSE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/445-10803.jpg ",
  reference: "BPS-062445",
},
{
  name: "POMPETTE GAZOIL PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/17-927800.jpg",
  reference: "BPS-064017",
},
{
  name: "CARTOUCHE FILTRE GAZOIL",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925423.jpg ",
  reference: "BPS-065032",
},
{
  name: "PARAHUILE FUSEE ",
  categories: " GROUPE POND ",
  image: "../image_produit/914-50047.jpg",
  reference: "BPS-064904",
},
{
  name: "FILTRE HYDRAULIQUE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/32-913500.jpg ",
  reference: "BPS-067032",
},
{
  name: "FILTRE BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/581-18076.jpg",
  reference: "BPS-068581",
},
{
  name: "FILTRE A AIR INTERIEUR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925683.jpg",
  reference: "BPS-070032",
},
{
  name: "FILTRE A AIR EXTERIEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925682.jpg ",
  reference: "BPS-071032",
},
{
  name: "FILTRE A AIR INT.+EXT. HMK",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-903601-602.jpg",
  reference: "BPS-072032",
},
{
  name: "FILTRE A AIR INT.+EXT. PERKINS ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-915801-802.jpg",
  reference: "BPS-073032",
},
{
  name: "FILTRE A HUILE MOTEUR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04133.jpg ",
  reference: "BPS-074320",
},
{
  name: "FILTRE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07155.jpg",
  reference: "BPS-075320",
},
{
  name: "PREFILTRE GAZOIL",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925915.jpg",
  reference: "BPS-076032",
},
{
  name: "NOIX SEMI ARBRE AV",
  categories: " GROUPE POND ",
  image: "../image_produit/914-86203.jpg",
  reference: "BPS-077914",
},
{
  name: "BOUCHON CACHE REDUCTEUR ",
  categories: " GROUPE POND ",
  image: "../image_produit/826-00425.jpg",
  reference: "BPS-078826",
},
{
  name: "PASTILLE REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10208.jpg",
  reference: "BPS-079450",
},
{
  name: "JOINT REDUCTEUR ",
  categories: " GROUPE POND ",
  image: "../image_produit/828-00196.jpg",
  reference: "BPS-080828",
},
{
  name: "TRANSPENDEUR ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-12702.jpg",
  reference: "BPS-081450",
},
{
  name: "KING POSTE NOIR ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/904-20140.jpg",
  reference: "BPS-082904",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00100.jpg",
  reference: "BPS-083991",
},
{
  name: " NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00102.jpg",
  reference: "BPS-084991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00103.jpg",
  reference: "BPS-085991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00152.jpg",
  reference: "BPS-086991",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00156.jpg",
  reference: "BPS-087991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00157.jpg",
  reference: "BPS-088991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00110.jpg",
  reference: "BPS-089991",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00145.jpg",
  reference: "BPS-092991",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00148.jpg",
  reference: "BPS-093991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00147.jpg",
  reference: "BPS-094991",
},
{
  name: "FEUX ARRIERE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50018.jpg",
  reference: "BPS-096700",
},
{
  name: "CACHE FEUX ARRIERE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50024.jpg",
  reference: "BPS-097700",
},
{
  name: "FEUX AVANT DROIT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50055.jpg",
  reference: "BPS-095/1.700",
},
{
  name: "FEUX AVANT GAUCHE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50054.jpg ",
  reference: "BPS-095700 ",
},
{
  name: "CLE DE CONTACTE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-45501.jpg",
  reference: "BPS-103701",
},
{
  name: "CONTACTE ELECTRIQUE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-80184.jpg",
  reference: "BPS-104701",
},
{
  name: "FILTRE GAZOIL HMK",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-912001.jpg",
  reference: "BPS-105032",
},
{
  name: "FILTRE A HUILE PERKINS ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-100073.jpg",
  reference: "BPS-106002",
},
{
  name: "KING POSTE JAUNE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/904-09400.jpg",
  reference: "BPS-108904",
},
{
  name: "LAME GUIDE FLECHE TELESCOPIQUE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-03215-4764.jpg",
  reference: "BPS-110123",
},
{
  name: "CABLE ACCELERATEUR PERKINS ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/910-48801.jpg",
  reference: "BPS-111910",
},
{
  name: "LEVIER DE CABLE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/910-43500.jpg",
  reference: "BPS-112910",
},
{
  name: "CACHE CALE DE REGLAGE CRIQUE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-06014.jpg",
  reference: "BPS-113123",
},
{
  name: "CACHE CALE DE REGLAGE CRIQUE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-06015.jpg",
  reference: "BPS-114123",
},
{
  name: "CABLE ACCELERATEUR MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/910-60216.jpg",
  reference: "BPS-115910",
},
{
  name: "CABLE ACCELERATEUR MOTEUR JCB AVEC MANETTE",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/910-60236.jpg",
  reference: "BPS-115/1.910",
},
{
  name: "POMPETTE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07040.jpg",
  reference: "BPS-116320",
},
{
  name: "TURBO MOTEUR PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-203160.jpg",
  reference: "BPS-118002",
},
{
  name: "BOULE DE ROTULE DE DIRECTION",
  categories: " GROUPE POND ",
  image: "../image_produit/331-23193.jpg",
  reference: "BPS-119331",
},
{
  name: "CALE DE NECESSAIRE DISTRIBUTEUR ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/25-975704.jpg",
  reference: "BPS-120025",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00099.jpg",
  reference: "BPS-122991",
},
{
  name: "MAITRE CYLINDRE DE FREIN",
  categories: " GROUPE POND ",
  image: "../image_produit/15-920389.jpg",
  reference: "BPS-123015",
},
{
  name: "CARTAIRE DIFFERENTIEL ",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10800.jpg",
  reference: "BPS-124450",
},
{
  name: "ECROU DE CRIQUE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/128-10850.jpg",
  reference: "BPS-125128",
},
{
  name: "PARAHUILE BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/904-05100.jpg",
  reference: "BPS-126904",
},
{
  name: "BAGUE EN ACIER",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00176.jpg",
  reference: "BPS-129809",
},
{
  name: "BAGUE EN ACIER",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00131.jpg",
  reference: "BPS-130809",
},
{
  name: "AXE DE GODET AVANT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/811-90483.jpg",
  reference: "BPS-131811",
},
{
  name: "AXE DE GODET ARRIERE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/911-12400.jpg",
  reference: "BPS-132911",
},
{
  name: "BAGUE DE GODET",
  categories: " GROUPE CABINE ",
  image: "../image_produit/G65-0.jpg ",
  reference: "BPS-133G65 ",
},
{
  name: "BAGUE EN ACIER",
  categories: " GROUPE CABINE ",
  image: "../image_produit/1208-0031.jpg",
  reference: "BPS-134120",
},
{
  name: "RETROVISEUR ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/123-04970.jpg",
  reference: "BPS-135123",
},
{
  name: "CACHE CRIQUE PLASTIC",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-06023.jpg",
  reference: "BPS-140123",
},
{
  name: "JOINT DISTRIBUTEUR",
  categories: " GROUPE BOITE ",
  image: "../image_produit/813-50055.jpg",
  reference: "BPS-141813",
},
{
  name: "CHAP DE CARDON",
  categories: " GROUPE POND ",
  image: "../image_produit/450-27200.jpg",
  reference: "BPS-142450",
},
{
  name: "COMODO MARCHE AV/AR ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-80296.jpg",
  reference: "BPS-143701",
},
{
  name: "BAGUE CENTRAL ",
  categories: " GROUPE POND ",
  image: "../image_produit/829-00548.jpg",
  reference: "BPS-145829",
},
{
  name: "BAGUE EN ACIER",
  categories: " GROUPE CABINE ",
  image: "../image_produit/1208-0023.jpg",
  reference: "BPS-148120",
},
{
  name: "BOUCHON RESERVOIR GAZOIL  JCB ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/123-05892.jpg ",
  reference: "BPS-149123",
},
{
  name: "SUPPORT MOTEUR PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/123-03138.jpg",
  reference: "BPS-150123",
},
{
  name: "SUPPORT  CABINE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-18441-42.jpg",
  reference: "BPS-151331",
},
{
  name: "BRAS RETROVISEUR GAUCHE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-26945.jpg",
  reference: "BPS-154331",
},
{
  name: "BRAS RETROVISEUR GAUCHE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/123-04969.jpg",
  reference: "BPS-154/1.123",
},
{
  name: "BRAS RETROVISEUR DROIT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-26946.jpg",
  reference: "BPS-155331",
},
{
  name: "BRAS RETROVISEUR DROIT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/123-04968.jpg",
  reference: "BPS-155/1.123",
},
{
  name: "CLAPET DE REGLAGE PRINCIPALE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/25-618901.jpg",
  reference: "BPS-156025",
},
{
  name: "SUPPORT VENTILATEUR MOTEUR  AK ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-201357.jpg",
  reference: "BPS-158002",
},
{
  name: "BAGUE REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/450-12703.jpg",
  reference: "BPS-159450",
},
{
  name: "BOULON M14X70mm long",
  categories: " GROUPE POND ",
  image: "../image_produit/826-01060.jpg",
  reference: "BPS-160826",
},
{
  name: "BOULON DE FIXATION",
  categories: " GROUPE POND ",
  image: "../image_produit/826-01206.jpg",
  reference: "BPS-161826",
},
{
  name: "AXE CENTRAL ",
  categories: " GROUPE POND ",
  image: "../image_produit/811-10091.jpg ",
  reference: "BPS-162811",
},
{
  name: "CEINTURE FLEXIBLE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-08014.jpg",
  reference: "BPS-163123",
},
{
  name: "FILTRE TRANSMISSION",
  categories: " GROUPE BOITE ",
  image: "../image_produit/02-100284.jpg",
  reference: "BPS-166002",
},
{
  name: "PATIN DE FREIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/15-920103.jpg",
  reference: "BPS-167015",
},
{
  name: "PALIER SUPPORT VENTULATEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-200010.jpg",
  reference: "BPS-168002",
},
{
  name: "POMPE A EAU JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04542.jpg",
  reference: "BPS-169320",
},
{
  name: "TENDEUR DE COURROIE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08759.jpg ",
  reference: "BPS-170320",
},
{
  name: "POLIE FIXE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08530.jpg",
  reference: "BPS-171320",
},
{
  name: "COURROIE TRACTOPELLE 2002 mm",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08608.jpg ",
  reference: "BPS-172320",
},
{
  name: "COURROIE TELESCOPIQUE 1855mm ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08599.jpg",
  reference: "BPS-173320",
},
{
  name: "ROULEMENT SEMI ARBRE AV ",
  categories: " GROUPE POND ",
  image: "../image_produit/907-08400.jpg",
  reference: "BPS-174907",
},
{
  name: "CHAP DE CARDON HMK",
  categories: " GROUPE POND ",
  image: "../image_produit/914-30902.jpg ",
  reference: "BPS-175/1.914",
},
{
  name: "CHAP CARDON 106*35",
  categories: " GROUPE POND ",
  image: "../image_produit/332-C1072.jpg",
  reference: "BPS-175/2.332",
},
{
  name: "MANO DE HUILE MOTEUR JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04046.jpg ",
  reference: "BPS-176320",
},
{
  name: "MANO HUILE MOTEUR AA-AB-AK ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/701-80225.jpg ",
  reference: "BPS-177701",
},
{
  name: "MANO DE TEMPERATURE MOTEUR AK ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/716-12800.jpg",
  reference: "BPS-178716",
},
{
  name: "MANO DE TEMPERATURE 3 FICHES ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04588.jpg",
  reference: "BPS-179320",
},
{
  name: "MANO HUILE DE BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/701-41600.jpg",
  reference: "BPS-180701",
},
{
  name: "MANO DE BOITE PAWERSHIFT ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/701-80591.jpg",
  reference: "BPS-181701",
},
{
  name: "MANO POMPE INJECTION N.M. ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/716-30255.jpg ",
  reference: "BPS-182716",
},
{
  name: "MANO DE POMPE INJECTION A.M. ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/17-105201.jpg ",
  reference: "BPS-183017",
},
{
  name: "ENTRETOISE AXE CENTRAL ",
  categories: " GROUPE POND ",
  image: "../image_produit/819-00137.jpg",
  reference: "BPS-184819",
},
{
  name: "FICHE DE BOBINE",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/721-10495.jpg",
  reference: "BPS-186721",
},
{
  name: "POMPETTE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925735.jpg",
  reference: "BPS-187032",
},
{
  name: "CUVETTE POMPETTE GAZOIL  JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925708.jpg ",
  reference: "BPS-188032",
},
{
  name: "VIS+COURONE POND  AVANT 13/38",
  categories: " GROUPE POND ",
  image: "../image_produit/458-70189.jpg ",
  reference: "BPS-190458",
},
{
  name: "FILTRE HYDRAULIQUE A.M. ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/581-06301.jpg ",
  reference: "BPS-191581",
},
{
  name: "ARBRE COMPLET 1275 mm ",
  categories: " GROUPE POND ",
  image: "../image_produit/914-88100.jpg",
  reference: "BPS-192914",
},
{
  name: "ARBRE COMPLET 825 mm ",
  categories: " GROUPE   PO ND",
  image: "../image_produit/914-88200.jpg",
  reference: "BPS-193914",
},
{
  name: " MOYEU 5 TROUS",
  categories: " GROUPE POND ",
  image: "../image_produit/450-10221.jpg",
  reference: "BPS-194450",
},
{
  name: "ROTULE DE DIRECTION 4CX ",
  categories: " GROUPE POND ",
  image: "../image_produit/126-02419.jpg",
  reference: "BPS-195126",
},
{
  name: "SOUFFLET ARRIERE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/332-F1130.jpg",
  reference: "BPS-196332",
},
{
  name: "SOUFFLET AVANT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-25685.jpg",
  reference: "BPS-197331",
},
{
  name: "DISQUE BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/331-16520.jpg ",
  reference: "BPS-198331",
},
{
  name: "TOLE CONVERTISSEUR N.M. ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/04-501700.jpg",
  reference: "BPS-199004",
},
{
  name: "SEGMENT BOITE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/904-50024.jpg ",
  reference: "BPS-200904",
},
{
  name: "MANO TEMPERATURE JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04554.jpg",
  reference: "BPS-201320",
},
{
  name: "COUVERCLE  DISTRIBUTION AK-AR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-201823.jpg",
  reference: "BPS-202002",
},
{
  name: "ECROU VIS M30",
  categories: " GROUPE POND ",
  image: "../image_produit/826-01744.jpg",
  reference: "BPS-203826",
},
{
  name: "BAGUE VERIN DE ROTATION",
  categories: " GROUPE CABINE ",
  image: "../image_produit/831-10229.jpg",
  reference: "BPS-204831",
},
{
  name: "BAGUE VERIN DE ROTATION",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00177.jpg",
  reference: "BPS-205809",
},
{
  name: "AXE  PIVOT FLECHE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/811-70098.jpg",
  reference: "BPS-206811",
},
{
  name: "VERIN DE PORTE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/128-13052.jpg",
  reference: "BPS-207128",
},
{
  name: "VERIN DE PORTE CABINE ARRIERE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-28215.jpg ",
  reference: "BPS-208331",
},
{
  name: "COMODO DE LUMIERE",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-80297.jpg ",
  reference: "BPS-209701",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00115.jpg",
  reference: "BPS-210991",
},
{
  name: "CIRCLIPS COURONE REDUCTEUR",
  categories: " GROUPE POND ",
  image: "../image_produit/821-00210.jpg",
  reference: "BPS-211821",
},
{
  name: "JEUX DE JOINT PISTON DE FREIN TELESCOPIQUE ",
  categories: " GROUPE POND ",
  image: "../image_produit/813-50014-15.jpg",
  reference: "BPS-212813",
},
{
  name: "INDICATEUR GAZOIL ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/704-50098.jpg",
  reference: "BPS-214704",
},
{
  name: "INDICATEUR TEMPERATURE",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/704-50099.jpg",
  reference: "BPS-215704",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00098.jpg",
  reference: "BPS-216991",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-10142.jpg",
  reference: "BPS-217991",
},
{
  name: "FILTRE A AIR TELESCOPIQUE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-917804-805.jpg ",
  reference: "BPS-218032",
},
{
  name: "FILTRE GAZOIL",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07394.jpg",
  reference: "BPS-219320",
},
{
  name: "CALE TEFLON DE ROTATION",
  categories: " GROUPE POND ",
  image: "../image_produit/823-10270.jpg",
  reference: "BPS-220823",
},
{
  name: "BOULON KING POSTE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/826-11235.jpg",
  reference: "BPS-221826",
},
{
  name: "BAGUE AXE CENTRAL CHARIOT",
  categories: " GROUPE POND ",
  image: "../image_produit/831-10211.jpg",
  reference: "BPS-222831",
},
{
  name: "TIKET JCB AVANT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/817-17858.jpg",
  reference: "BPS-223817",
},
{
  name: "TIKET JCB ARRIERE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/817-17893.jpg",
  reference: "BPS-224817",
},
{
  name: "CROCHET AXE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/821-00517.jpg",
  reference: "BPS-225821",
},
{
  name: "CROCHET AXE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/826-00874.jpg",
  reference: "BPS- ",
},
{
  name: "BOUCHON D’EAU MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/477-00223.jpg",
  reference: "BPS-227477",
},
{
  name: "BOUCHON D’EAU MOTEUR PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/123-06578.jpg",
  reference: "BPS-228123",
},
{
  name: "BOUCHON HYDRAULIQUE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/32-925421.jpg",
  reference: "BPS-229032",
},
{
  name: "POIGNE DE MANETTE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/128-12635.jpg",
  reference: "BPS-230128",
},
{
  name: "POIGNE DE MANETTE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/128-12634.jpg",
  reference: "BPS-230/1.128",
},
{
  name: "BOUCHON GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/332-F4780.jpg",
  reference: "BPS-233332",
},
{
  name: "POIGNE DE PORTE INTERIEUR GAUCHE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/826-11105.jpg",
  reference: "BPS-234826",
},
{
  name: "BLOC FENETRE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-31071.jpg",
  reference: "BPS-235331",
},
{
  name: "POCHETTE JOINT DE SOUPAPE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09200.jpg",
  reference: "BPS-236320",
},
{
  name: "VENTILATEUR MOTEUR JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/30-925526.jpg",
  reference: "BPS-237030",
},
{
  name: "EMBRAYAGE VENTILATEUR COMPLET",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/30-926572.jpg",
  reference: "BPS-238030",
},
{
  name: "POCHETTE REVISION SUPERIEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09216.jpg",
  reference: "BPS-239320",
},
{
  name: "POCHETTE REVISION INFERIEUR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09281.jpg",
  reference: "BPS-240320",
},
{
  name: "JOINT DE CACHE SOUPAPE",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07580.jpg",
  reference: "BPS-241320",
},
{
  name: "JOINT DE CULASS ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-02608.jpg",
  reference: "BPS-242320",
},
{
  name: "JOINT COLLECTEUR ECHAPPEMENT ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-06080.jpg",
  reference: "BPS-243320",
},
{
  name: "JOINT COLLECTEUR ADMISSION ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-05550.jpg",
  reference: "BPS-244320",
},
{
  name: "JOINT REFREGERANT",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04113.jpg",
  reference: "BPS-245320",
},
{
  name: "PARAHUILE ARRIERE MOTEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03029.jpg",
  reference: "BPS-246320",
},
{
  name: "PARAHUILE  AVANT MOTEUR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03119.jpg",
  reference: "BPS-247320",
},
{
  name: "TUBE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07087.jpg",
  reference: "BPS-248320 ",
},
{
  name: "TUBE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07059.jpg",
  reference: "BPS-249320",
},
{
  name: "CHEMISE KING POSTE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/128-14725.jpg",
  reference: "BPS-251128",
},
{
  name: "AILE TELESCOPIC ARRIERE DROIT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/400-D5247.jpg",
  reference: "BPS-252400",
},
{
  name: "AILE TELESCOPIC ARRIERE GAUCHE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/400-D7827.jpg",
  reference: "BPS-253400",
},
{
  name: "AILE TELESCOPIC AVANT DROIT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/332-C7715.jpg",
  reference: "BPS-254332",
},
{
  name: "AILE TELESCOPIC AVANT GAUCHE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/400-D5365.jpg",
  reference: "BPS-255400",
},
{
  name: "AXE CENTRAL ROTATION FLECHE",
  categories: " GROUPE POND ",
  image: "../image_produit/911-40104.jpg",
  reference: "BPS-256911",
},
{
  name: "TOLE CONVERTISSEUR 4*6 TROUS",
  categories: " GROUPE BOITE ",
  image: "../image_produit/04-600864.jpg",
  reference: "BPS-257004",
},
{
  name: "RACCORD VERIN DE ROTATION",
  categories: " GROUPE CABINE ",
  image: "../image_produit/559-90056.jpg",
  reference: "BPS-258559",
},
{
  name: "AXE CENTRAL INFERIEUR ROTATION FLECHE ",
  categories: " GROUPE POND ",
  image: "../image_produit/911-40048.jpg",
  reference: "BPS-259911",
},
{
  name: "NECESSAIRE ROTATION FLECHE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00018.jpg",
  reference: "BPS-260991",
},
{
  name: "POIGNE DE PORTE N.M. ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-31709.jpg ",
  reference: "BPS-261331",
},
{
  name: "POMPE A VIDE MOTEUR PERKINS ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/15-920000.jpg",
  reference: "BPS-263015",
},
{
  name: "POMPE A VIDE  TELESCOPIC MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/15-920200.jpg ",
  reference: "BPS-264015",
},
{
  name: "TURBO MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-06047.jpg",
  reference: "BPS-265320",
},
{
  name: "NOIX SEMI ARBRE 35*96",
  categories: " GROUPE POND ",
  image: "../image_produit/914-86403.jpg",
  reference: "BPS-268914",
},
{
  name: "CROISILLON 35*93",
  categories: " GROUPE POND ",
  image: "../image_produit/914-84101.jpg",
  reference: "BPS-269914",
},
{
  name: "RONDELLE KING POSTE GAUCHE",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/823-10331.jpg",
  reference: "BPS-270823",
},
{
  name: "RONDELLE KING POSTE DROIT ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/823-10332.jpg",
  reference: "BPS-271823",
},
{
  name: "BIELLE DE GODET",
  categories: " GROUPE CABINE ",
  image: "../image_produit/126-00247.jpg",
  reference: "BPS-272126",
},
{
  name: "BAGUE AXE PIVOT CHARIOT",
  categories: " GROUPE CABINE ",
  image: "../image_produit/808-00296.jpg",
  reference: "BPS-273808",
},
{
  name: "BAGUE DE VERIN LEVAGE FLECHE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00126.jpg",
  reference: "BPS-275809",
},
{
  name: "BAGUE INFERIEUR VERIN BALANCIER",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00179.jpg",
  reference: "BPS-276809",
},
{
  name: "JEUX DE JOINT BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/828-10181-82.jpg",
  reference: "BPS-277828",
},
{
  name: "TIKET JCB 540X169",
  categories: " GROUPE CABINE ",
  image: "../image_produit/332-G3450.jpg",
  reference: "BPS-278332",
},
{
  name: "TIKET JCB 825X257",
  categories: " GROUPE CABINE ",
  image: "../image_produit/332-G3451.jpg",
  reference: "BPS-279332",
},
{
  name: "CHAP BOITE HMK ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/459-70138.jpg",
  reference: "BPS-280459",
},
{
  name: "GRAISSEUR 1/8 ",
  categories: " GROUPE POND+CABINE",
  image: "../image_produit/1450-0001.jpg",
  reference: "BPS-282145",
},
{
  name: "VENTILATEUR PERKINS JCB/HMK ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/123-05911.jpg",
  reference: "BPS-283123",
},
{
  name: "DURITE REFREGERANT BOITE",
  categories: " GROUPE BOITE ",
  image: "../image_produit/834-00666.jpg",
  reference: "BPS-284834",
},
{
  name: "RESSORT CABLE ACCELERATEUR PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/814-00193.jpg",
  reference: "BPS-285814",
},
{
  name: "RESSORT CABLE ACCELERATEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/814-00289.jpg",
  reference: "BPS-286814",
},
{
  name: "ROTULE TIGE MANETTE M8 ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/826-00927.jpg",
  reference: "BPS-287826",
},
{
  name: "CHARNIERE DE PORTE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/128-11287.jpg",
  reference: "BPS-288128",
},
{
  name: "SUPPORT VENTILATEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08550.jpg",
  reference: "BPS-289320",
},
{
  name: "PARAHUILE MOYEU CARRARO ",
  categories: " GROUPE POND ",
  image: "../image_produit/12018035.jpg",
  reference: "BPS-290120",
},
{
  name: "BOUTON LUMIERE",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-60004.jpg",
  reference: "BPS-291701",
},
{
  name: "FILTRE HYDRAULIQUE HMK",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/F28-51001.jpg",
  reference: "BPS-292F28",
},
{
  name: "VIS D’ATTACHE CROISILLON",
  categories: " GROUPE POND ",
  image: "../image_produit/826-11635.jpg",
  reference: "BPS-293826",
},
{
  name: "PISTON JCB STD ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09249.jpg",
  reference: "BPS-294320",
},
{
  name: "SEGMENT PISTON JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09299.jpg",
  reference: "BPS-295320",
},
{
  name: "COUSSINET BIELLE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03270.jpg",
  reference: "BPS-296320",
},
{
  name: "COUSSINET DE LIGNE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09335.jpg",
  reference: "BPS-297320",
},
{
  name: "CALE LATERAL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09208.jpg",
  reference: "BPS-298320",
},
{
  name: "BAGUE DE BIELLE",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03017.jpg",
  reference: "BPS-299320",
},
{
  name: "SOUPAPE ADMISSION ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03612.jpg",
  reference: "BPS-300320",
},
{
  name: "SOUPAPE ECHAPMENT ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03616.jpg",
  reference: "BPS-301",
},
{
  name: "BOUCHON CACHE SOUPAPE",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04090.jpg",
  reference: "BPS-302320",
},
{
  name: "CACHE REFREGERANT ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04210.jpg",
  reference: "BPS-303320",
},
{
  name: "THERMOSTAT ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04618.jpg",
  reference: "BPS-304320",
},
{
  name: "DEMAREUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09035.jpg",
  reference: "BPS-305320",
},
{
  name: "ALTERNATEUR JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08560.jpg",
  reference: "BPS-306320",
},
{
  name: "MAITRE CYLINDRE TELESCOPIC",
  categories: " GROUPE POND ",
  image: "../image_produit/15-920208.jpg",
  reference: "BPS-307015",
},
{
  name: "FEUX TELESCOPIC  AVANT GAUCHE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50192.jpg",
  reference: "BPS-308700",
},
{
  name: " FEUX TELESCOPIC  AVANT DROIT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50193.jpg",
  reference: "BPS-309700",
},
{
  name: "CACHE FEUX DE STOP TELESCOPIC",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50072.jpg",
  reference: "BPS-310700",
},
{
  name: "CACHE FEUX DE POSITION TELESCOPIC ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50073.jpg",
  reference: "BPS-311700",
},
{
  name: "CACHE FEUX DE RECUL TELESCOPIC",
  categories: " GROUPE CABINE ",
  image: "../image_produit/700-50074.jpg",
  reference: "BPS-312700",
},
{
  name: "BAGUE VERIN ROTATION",
  categories: " GROUPE CABINE ",
  image: "../image_produit/809-00137.jpg",
  reference: "BPS-314809",
},
{
  name: "CREPINE D’ASPIRATION HYDRAULIQUE ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/32-920300.jpg",
  reference: "BPS-315032",
},
{
  name: "BOBINE ELECTROVANE  N.M. ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/717-20142.jpg",
  reference: "BPS-316717",
},
{
  name: "NECESSAIRE DE VERIN",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20021.jpg",
  reference: "BPS-317991",
},
{
  name: " NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20022.jpg ",
  reference: "BPS-318991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20030.jpg ",
  reference: "BPS-319991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20023.jpg ",
  reference: "BPS-320991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/332-E8224.jpg ",
  reference: "BPS-321332",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20028.jpg ",
  reference: "BPS-322.991",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-20029.jpg ",
  reference: "BPS-323991",
},
{
  name: "DURITE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/332-C4382.jpg",
  reference: "BPS-324332",
},
{
  name: "ROULEMENT AIGUILLE DIRECTION",
  categories: " GROUPE POND ",
  image: "../image_produit/917-02000.jpg",
  reference: "BPS-325917",
},
{
  name: "RESSORT PEDAL ACCELERATEUR ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/814-00441.jpg",
  reference: "BPS-326814",
},
{
  name: "RONDELLE AXE GODET 45 mm",
  categories: " GROUPE CABINE ",
  image: "../image_produit/823-00470.jpg",
  reference: "BPS-327823",
},
{
  name: "MARCHE PIED INFERIEUR ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-27034.jpg",
  reference: "BPS-328331",
},
{
  name: "VOYANT RESERVOIR HYDRAULIQUE 50mm",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/123-08053.jpg",
  reference: "BPS-329123",
},
{
  name: "COURROIE JCB 4CX ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08600.jpg",
  reference: "BPS-330320",
},
{
  name: "VERIN CAPOT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-47026.jpg",
  reference: "BPS-331331",
},
{
  name: "MANO TEMPERATURE RG ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/716-30126.jpg",
  reference: "BPS-332716",
},
{
  name: "MANO HUILE MOTEUR RG ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/701-80327.jpg",
  reference: "BPS-333701",
},
{
  name: "AXE VERIN GODET ARRIERE INF.45*206",
  categories: " GROUPE CABINE ",
  image: "../image_produit/811-90409.jpg",
  reference: "BPS- 334811",
},
{
  name: "PARAHUILE CHAP BOITE HMK",
  categories: " GROUPE BOITE ",
  image: "../image_produit/904-20281.jpg",
  reference: "BPS-335904",
},
{
  name: "CIRCLIPS ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/823-00334.jpg",
  reference: "BPS-336823",
},
{
  name: "CONTRE DISQUE BOITE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/331-16516.jpg",
  reference: "BPS-337331",
},
{
  name: "AXE CENTRAL SUPERIEUR ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/811-90165.jpg",
  reference: "BPS-338811",
},
{
  name: "AMORTISSEUR CHAISE",
  categories: " GROUPE CABINE ",
  image: "../image_produit/40-910659.jpg",
  reference: "BPS-339040",
},
{
  name: "MARMITE ECHAPMENT ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/128-H2997.jpg ",
  reference: "BPS-340128",
},
{
  name: "JOINT DE MARMITE ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/320-06036.jpg",
  reference: "BPS-341320",
},
{
  name: "JOINT DE POMPE DE BOITE ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/813-50041.jpg",
  reference: "BPS-342813",
},
{
  name: "PARAHUILE CARTAIRE MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04162.jpg",
  reference: "BPS-343320",
},
{
  name: "NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00120.jpg",
  reference: "BPS-344991",
},
{
  name: " NECESSAIRE DE VERIN ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/991-00111.jpg ",
  reference: "BPS-345991",
},
{
  name: "COMPTEUR JCB ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/704-D7231.jpg",
  reference: "BPS-346704",
},
{
  name: "RESERVOIR D’EAU MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/128-15479.jpg",
  reference: "BPS-347128 ",
},
{
  name: "FICHE DE BOBINE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/717-20140.jpg",
  reference: "BPS-348717",
},
{
  name: "FICHE DE BOBINE 5 LIGTH",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/700-50190.jpg",
  reference: "BPS-349700",
},
{
  name: "BOITE FUSIBLE ",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/716-30077.jpg",
  reference: "BPS-350716",
},
{
  name: "COUPE COURANT",
  categories: " GROUPE ELECTRIQUE ",
  image: "../image_produit/701-20800.jpg",
  reference: "BPS-351701",
},
{
  name: "POCHETTE REVISION SUPERIEUR PERKINS",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/02-201849.jpg",
  reference: "BPS-352002 ",
},
{
  name: "CARDON AVANT ",
  categories: " GROUPE POND ",
  image: "../image_produit/914-56400.jpg",
  reference: "BPS-353914",
},
{
  name: "VILBREKIN MOTEUR JCB ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03336.jpg",
  reference: "BPS-354320",
},
{
  name: "CREPINE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-902200.jpg",
  reference: "BPS-355032",
},
{
  name: "JOINT DISTRIBUTEUR ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/813-M2979.jpg",
  reference: "BPS-356813",
},
{
  name: "VERIN DE CAPOT MOTEUR ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-37268.jpg",
  reference: "BPS-357/1.331",
},
{
  name: "RADIATEUR D’EAU 3CX ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/30-915200.jpg",
  reference: "BPS-358030",
},
{
  name: "CHEMISE BRUT MOTEUR JCB",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-00001.jpg",
  reference: "BPS-359320",
},
{
  name: "SOUFFLET TIROIR DISTRIBUTEUR",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/25-613701.jpg",
  reference: "BPS-360025",
},
{
  name: "PARAHUILE POMPE CONVERTISSEUR ",
  categories: " GROUPE BOITE ",
  image: "../image_produit/904-20226.jpg",
  reference: "BPS-361904",
},
{
  name: "CHARNIERE DE PORTE TELESCOPIC ",
  categories: " GROUPE CABINE ",
  image: "../image_produit/331-31247.jpg",
  reference: "BPS-362331",
},
{
  name: "CABLE ACCELERATEUR TELESCOPIC ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/331-51329.jpg",
  reference: "BPS-363331",
},
{
  name: "NECESSAIRE DE VERIN TELESCOPIC ",
  categories: " GROUPE HYDRAULIQUE ",
  image: "../image_produit/332-E3218.jpg ",
  reference: "BPS-364332",
},
{
  name: "COUSSINET DE BIELLE 0.50 mm ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09207.jpg",
  reference: "BPS-365320",
},
{
  name: "COUSSINET DE LIGNE 0.50 mm",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-09337.jpg",
  reference: "BPS-366320",
},
{
  name: "BAGUE CHAMBRE INJECTEUR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-02611.jpg",
  reference: "BPS-367320",
},
{
  name: "PARAHUILE SOUPAPE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-03533.jpg",
  reference: "BPS-368320",
},
{
  name: "ATTACHE TUBE GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07189.jpg ",
  reference: "BPS-369320",
},
{
  name: "REFREGERANT MOTEUR COMPLET ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-04212.jpg",
  reference: "BPS-370320",
},
{
  name: "VALVE DE VITESSE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/25-220994.jpg",
  reference: "BPS-371025",
},
{
  name: "CORPS DE FILTRE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/32-925684.jpg ",
  reference: "BPS-372032",
},
{
  name: "DURITE D’AIR ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/332-C0370.jpg ",
  reference: "BPS-373332",
},
{
  name: "AXE POMPETTE ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07038.jpg",
  reference: "BPS-374320 ",
},
{
  name: "TUBE DE RETOUR GAZOIL ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-07225.jpg",
  reference: "BPS-375320",
},
{
  name: "POLIE FIXE PK TELESCOPIC ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/320-08564.jpg",
  reference: "BPS-376320",
},
{
  name: "ARRACHE POMPE INJECTION ",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/892-01155.jpg",
  reference: "BPS-377892",
},
{
  name: "CLE DE POMPE INJECTION",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/892-01179.jpg",
  reference: "BPS-378892",
},
{
  name: "FLANGE ADAPTEUR",
  categories: " GROUPE MOTEUR ",
  image: "../image_produit/903-20774.jpg",
  reference: "BPS-379903",
},
{
  name: " ",
  categories: " GROUPE   ",
  image: "../image_produit/ ",
  reference: "BPS- ",
},
{
  name: " ",
  categories: " GROUPE   ",
  image: "../image_produit/ ",
  reference: "BPS- ",
},

  ];
  const [search, setSearch] = useState("") ;
  
  
  



  return (
    <div className="App">
      <Navbar search={search} setSearch={setSearch} />
      <div className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Categories" element={<Categories product={product} search={search}/>} />
          <Route path="/Contact" element={<Contact />} />
         
          <Route
            path="/Categories/GroupePond"
            element={<DetailsPond product={product} search={search} />}
          />
           <Route
            path="/Categories/GroupeBoite"
            element={<DetailsBoite product={product} search={search} />}
          />
          <Route
            path="/Categories/GroupeMoteur"
            element={<DetailsMoteur product={product} search={search} />}
          />
          <Route
            path="/Categories/GroupeHydraulique"
            element={<DetailsHydraulique product={product} search={search} />}
          />
           <Route
            path="/Categories/GroupeCabine"
            element={<DetailsCabine product={product} search={search} />}
          />
        </Routes>
        

        
      </div>

      <iframe
        id="map"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d819584.0850963612!2d9.757332886983077!3d36.63841232779432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd35ccbed3e9e7%3A0x7874fbbedf8bda1f!2sBENZID%20PI%C3%88CES%20ET%20SERVICES%20-%20BPS%20-%20TUNIS!5e0!3m2!1sfr!2stn!4v1668254733328!5m2!1sfr!2stn"
      ></iframe>

      <Footer />
    </div>
  );
}

export default App;
